import { useApolloClient } from '@apollo/client';
import { useEffect, useRef } from 'react';
import { gql } from '@/__generated__';
import { useSubscription } from '@/apollo/use-subscription.ts';

const OnCustomCollectionsChanged = gql(`
  subscription OnCustomCollectionsChanged {
    onCustomCollectionsChanged
  }
`);

// Signup gifts land as separate jobs; one reload covers the burst.
const RELOAD_DEBOUNCE_MS = 500;

export const CustomCollectionsChangedSubscription = () => {
  const client = useApolloClient();
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  useSubscription(OnCustomCollectionsChanged, {
    onData: () => {
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => {
        void client.refetchQueries({ include: ['streamDecksQuery'] });
      }, RELOAD_DEBOUNCE_MS);
    },
  });

  return null;
};
